import { Component, OnInit } from '@angular/core';
import { ChartData, ChartOptions, ChartType } from 'chart.js';

@Component({
    selector: 'app-gsa-dashboard',
    templateUrl: './gsa-dashboard.component.html',
    styleUrls: ['./gsa-dashboard.component.less'],
    standalone: false
})
export class GsaDashboardComponent implements OnInit {

  //#region Line Chart Demo Example
  lineChartData: ChartData<'line'> = {
    labels: ['Test 1', 'Test 2', 'Test 3', 'Test 4', 'Test 5', 'Test 6'],
    datasets: [
      {
        data: [30, 8, 27, 17, 28, 15],
        label: 'Line Chart Demo',
        borderColor: 'black',
        backgroundColor: 'rgba(255,255,0,0.28)',
      }
    ]
  };
  lineChartOptions: ChartOptions<'line'> = { responsive: true };
  lineChartLegend = true;
  lineChartPlugins: any[] = [];
  lineChartType: ChartType = 'line';
  //#endregion

  //#region Bar Chart Demo Example
  barChartData: ChartData<'bar'> = {
    labels: ['Test 1', 'Test 2', 'Test 3', 'Test 4', 'Test 5', 'Test 6'],
    datasets: [
      { data: [45, 37, 60, 70, 46, 33], label: 'Bar Chart Demo' }
    ]
  };
  barChartOptions: ChartOptions<'bar'> = { responsive: true };
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins: any[] = [];
  //#endregion

  //#region Doughnut Chart Demo Example
  doughnutChartData: ChartData<'doughnut'> = {
    labels: ['Test 1', 'Test 2', 'Test 3'],
    datasets: [{ data: [55, 25, 20] }]
  };
  doughnutChartType: ChartType = 'doughnut';
  //#endregion

  //#region Pie Chart Demo Example
  pieChartData: ChartData<'pie'> = {
    labels: ['TEST 1', 'TEST 2', 'TEST 3'],
    datasets: [{ data: [30, 50, 20] }]
  };
  pieChartOptions: ChartOptions<'pie'> = { responsive: true };
  pieChartType: ChartType = 'pie';
  pieChartLegend = true;
  pieChartPlugins: any[] = [];
  //#endregion

  constructor() {}

  ngOnInit(): void {}
}